

































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import VueRouter from "vue-router";
import { Howl, Howler } from "howler";
import MirrorCamera from "@/components/MirrorCamera.vue";
import Ruler from "@/components/Ruler.vue";
import FadeLayer from "@/components/FadeLayer.vue";
import getBpms from "@/libs/bpms";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: { MirrorCamera, Ruler, FadeLayer },
})
export default class Metronome extends Vue {
  public menu = ["フリー", "練習曲１", "練習曲２"];
  public currentMenu = this.menu[0];
  public registeredBpms = [120, 60, 98];
  public sheets = [null, "kiso1.png", "kiso2.png"];
  public canvas!: HTMLCanvasElement;
  public ctx!: CanvasRenderingContext2D;
  public metronome = new Image();
  public weight = new Image();
  public clickSound!: Howl;
  public bpmTemporary = 0;
  private bpms = new Array<number>();
  public isPlaying = false;
  public changeBpmDialog = false;
  public tabs = ["シンプル", "ミラー"];
  public currentTab = 0;
  public isLargeHight = true;
  public addingDialog = false;
  public newMenuName = "";
  public showGarbageBtn = false;
  public miniContHeight = 0;
  public isLightsOut = false;
  public readonly cameraId = "video";

  public mounted() {
    window.addEventListener("resize", () => {
      this.checkHight();
      const me = this;
      setTimeout(() => {
        this.setCanvasReso();
        this.preDraw();
      }, 1);
    });

    this.metronome.src = require("@/assets/metronome/metronome.png");
    this.weight.src = require("@/assets/metronome/metronome_weight.png");

    this.metronome.onload = () => this.preDraw();
    this.weight.onload = () => this.preDraw();

    this.clickSound = new Howl({
      src: [
        require("@/assets/metronome/click.wav"),
        require("@/assets/metronome/click.mp3"),
      ],
    });

    let _registeredBpms = localStorage.getItem("registeredBpms");
    if (_registeredBpms) this.registeredBpms = JSON.parse(_registeredBpms);
    let _menu = localStorage.getItem("menu");
    if (_menu) this.menu = JSON.parse(_menu);
  }

  public drawInit() {
    this.canvas = document.querySelector("#metronome") as HTMLCanvasElement;
    if (this.currentTab === 1)
      this.canvas = document.querySelector(
        /*"#mini-metronome"*/ "#overlay-metronome"
      ) as HTMLCanvasElement;

    this.ctx = this.canvas.getContext("2d")!;
    this.setCanvasReso();
    this.preDraw();
  }

  private loadCount = 0;
  private preDraw() {
    if (++this.loadCount < 3) return;
    this.draw(0);
  }

  private lastTime = 0;
  private reset = true;
  private beforeBeatTime = 0;
  private id = 0;
  private update() {
    this.id = requestAnimationFrame(this.update);
    if (this.reset) {
      this.lastTime = new Date().getTime();
      this.beforeBeatTime = -60 / this.bpm / 2 - 0.1;
      this.reset = false;
    }
    let timestamp = new Date().getTime() - this.lastTime;
    const k = 0.6;
    this.draw(k * Math.sin((this.bpm / 60) * Math.PI * (timestamp / 1000)));
    if (timestamp / 1000 - this.beforeBeatTime > 60 / this.bpm) {
      this.clickSound.stop();
      this.clickSound.play();
      this.beforeBeatTime += 60 / this.bpm;
    }
  }
  private draw(theta: number) {
    const width = this.ctx.canvas.clientWidth;
    const height = this.ctx.canvas.clientHeight;
    this.ctx.clearRect(0, 0, width, height);
    this.ctx.translate(width / 2, height);
    this.ctx.rotate(theta);
    this.ctx.drawImage(
      this.metronome,
      -height * 0.125 * 0.5,
      -height,
      height * 0.125,
      height
    );
    const weight_height = (height * 250) / this.weight.height;
    this.ctx.drawImage(
      this.weight,
      -height * 0.125 * 0.5,
      -weight_height -
        (height - weight_height) *
          (1 -
            (this.bpm - getBpms()[0]) /
              (getBpms()[getBpms().length - 1] - getBpms()[0])),
      height * 0.125,
      height
    );
    this.ctx.rotate(-theta);
    this.ctx.translate(-width / 2, -height);
  }

  public dpr = window.devicePixelRatio || 1;
  private setCanvasReso() {
    let cover = document.getElementById("canvas-cover")!;
    if (this.currentTab === 1)
      cover = document.getElementById(
        /*"mini-canvas-cover"*/ "overlay-canvas-cover"
      )!;
    let width = cover.clientWidth;
    let height = cover.clientHeight;

    this.canvas.width = width * this.dpr;
    this.canvas.height = height * this.dpr;

    this.ctx.scale(this.dpr, this.dpr);

    this.canvas.style.width = width + "px";
    this.canvas.style.height = height + "px";

    if (this.currentTab === 1) this.miniContHeight = /*height + 24*/ 80;
  }

  public plusBPM() {
    let minDiff = -1;
    let fixedBpmIndex = 0;
    getBpms().forEach((element, index) => {
      const diff = Math.abs(element - this.bpm);
      if (diff < minDiff || minDiff === -1) {
        minDiff = diff;
        fixedBpmIndex = index;
      }
    }, this);
    if (fixedBpmIndex + 1 < getBpms().length) {
      this.bpm = getBpms()[fixedBpmIndex + 1];
      this.reset = true;
      this.preDraw();
    }
  }
  public minusBPM() {
    let minDiff = -1;
    let fixedBpmIndex = 0;
    getBpms().forEach((element, index) => {
      const diff = Math.abs(element - this.bpm);
      if (diff <= minDiff || minDiff === -1) {
        minDiff = diff;
        fixedBpmIndex = index;
      }
    }, this);
    if (fixedBpmIndex - 1 >= 0) {
      this.bpm = getBpms()[fixedBpmIndex - 1];
      this.reset = true;
      this.preDraw();
    }
  }

  private currentId = 0;
  public btnClicked() {
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.reset = true;
      this.update();
    } else {
      cancelAnimationFrame(this.id);
      this.preDraw();
    }
  }

  public openChangeBpmDialog() {
    this.bpmTemporary = this.bpm;
    this.changeBpmDialog = true;
    setTimeout(() => (this.$refs.bpmField as HTMLDivElement).focus(), 100);
  }

  public closeChangeBpmDialog() {
    this.changeBpmDialog = false;
    scroll(0, 0);
  }

  public openAddingDialog() {
    this.addingDialog = true;
    this.newMenuName = "";
    setTimeout(() => (this.$refs.menuField as HTMLDivElement).focus(), 100);
  }
  public closeAddingDialog(isAdd: boolean) {
    if (isAdd) {
      this.menu.push(this.newMenuName);
      this.registeredBpms.push(120);
      this.currentMenu = this.newMenuName;
      localStorage.setItem("menu", JSON.stringify(this.menu));
      this.menuChanged();
    }
    this.addingDialog = false;
    scroll(0, 0);
  }
  public deleteMenu() {
    const menuIndexToBeDeleted = this.menu.indexOf(this.currentMenu);
    this.currentMenu = this.menu[menuIndexToBeDeleted - 1];
    this.menu.splice(menuIndexToBeDeleted, 1);
    this.registeredBpms.splice(menuIndexToBeDeleted, 1);
    localStorage.setItem("menu", JSON.stringify(this.menu));
    this.menuChanged();
  }

  public changeBpm() {
    if (this.bpmTemporary < getBpms()[0]) this.bpmTemporary = getBpms()[0];
    else if (this.bpmTemporary > getBpms()[getBpms().length - 1])
      this.bpmTemporary = getBpms()[getBpms().length - 1];
    this.bpm = this.bpmTemporary;
    this.closeChangeBpmDialog();
  }

  public menuChanged() {
    this.hideGarbageBtn();
    this.bpm = this.registeredBpms[this.menu.indexOf(this.currentMenu)];
    this.reset = true;
  }

  public get bpm() {
    return this.registeredBpms[this.menu.indexOf(this.currentMenu)];
  }

  public set bpm(newValue) {
    this.registeredBpms.splice(
      this.menu.indexOf(this.currentMenu),
      1,
      newValue
    );
    localStorage.setItem("registeredBpms", JSON.stringify(this.registeredBpms));
  }

  public get sheet() {
    let index = this.menu.indexOf(this.currentMenu);
    return index < this.sheets.length && !!this.sheets[index]
      ? require("@/assets/sheet/" + this.sheets[index])
      : null;
  }

  public checkHight() {
    this.isLargeHight = window.innerHeight > 450;
  }

  public menuClicked() {
    if (this.menu.indexOf(this.currentMenu) >= 3) this.showGarbageBtn = true;
  }

  public hideGarbageBtn() {
    const me = this;
    setTimeout(() => (me.showGarbageBtn = false), 100);
  }

  beforeRouteLeave(to: VueRouter, from: VueRouter, next: Function) {
    cancelAnimationFrame(this.id);
    next();
  }
}
